import { useContext, useEffect, useState } from "react";
import { getRentals } from "../api/apiRequests";
import { SessionContext } from "./wrappers/SessionWrapper";


const useRentals = ({ autoload = true, populateBookings, from, to } = {}) => {
  const { isLoggedIn } = useContext(SessionContext)
  const [rentals, setRentals] = useState()
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    if(autoload) refreshRentals()
    // eslint-disable-next-line
  }, [isLoggedIn, autoload, populateBookings, from, to])

  const refreshRentals = async () => {
    setLoading(true)
    if(isLoggedIn) {
      await getRentals({ populateBookings, from, to })
        .then(res =>
          setRentals(res.data))
        .catch(() =>
          alert("¡Ups!, estamos teniendo dificultades con el servidor. Espere un instante y recargue la página"))
      setLoading(false)
    }
  };

  return {
    rentals,
    refreshRentals,
    isLoading
  }
}

export default useRentals